@if (header) {
    <h4>{{ header }}</h4>
}
<div class="vc-pick-list-source-panel">
    <div class="vc-pick-list-header">
        <span class="h4-heading">{{ sourceLabel }}</span>
        @if (showSourceSearch) {
            <vc-input
                [label]="sourceSearchLabel"
                [placeholder]="sourceSearchPlaceholder"
                [showClear]="true"
                [prefixIcon]="'search'"
                [(value)]="sourceSearch"></vc-input>
        }
    </div>
    @if (showSourceSort) {
        <div class="vc-pick-list-column-header" (click)="onSourceSort()">
            <span>{{ sourceColumnHeader }}</span>
            <div class="space-pd-8">
                <div
                    class="vc-sort-header-arrow"
                    [class.vc-sort-header-arrow-asc]="sourceSortDirection === 'asc'"
                    [class.vc-sort-header-arrow-desc]="sourceSortDirection === 'desc'">
                    <div class="vc-sort-header-stem"></div>
                    <div class="vc-sort-header-indicator">
                        <div class="vc-sort-header-pointer-left"></div>
                        <div class="vc-sort-header-pointer-right"></div>
                        <div class="vc-sort-header-pointer-middle"></div>
                    </div>
                </div>
            </div>
        </div>
    }
    <mat-selection-list
        #sourceList
        cdkDropList
        class="vc-pick-list-selection-list vc-selection-list"
        [style.border-top-left-radius]="showSourceSort ? '0' : 'var(--field-border-radius)'"
        [style.border-top-right-radius]="showSourceSort ? '0' : 'var(--field-border-radius)'"
        [multiple]="multiselect"
        [tabIndex]="0"
        #todoList="cdkDropList"
        [disableRipple]="true"
        [cdkDropListData]="source"
        [cdkDropListConnectedTo]="[doneList]"
        [hideSingleSelectionIndicator]="true"
        [attr.aria-label]="sourceAriaLabel"
        (selectionChange)="onSourceChange($event)"
        (cdkDropListDropped)="drop($event)">
        @for (item of sortedSource | search: sourceSearchKey : sourceSearch; track item; let i = $index) {
            <mat-list-option cdkDrag class="vc-pick-list-option" [value]="item">
                <ng-container
                    *ngTemplateOutlet="sourceItemTemplate; context: { $implicit: item, index: i }"></ng-container>
            </mat-list-option>
        }
    </mat-selection-list>
</div>
<div class="vc-pick-list-buttons-panel">
    <vc-button
        aria-label="Move to right"
        mode="icon-secondary"
        iconName="chevron_right"
        [disabled]="moveToTargetButtonDisabled"
        (trigger)="onMoveToTarget()"></vc-button>
    @if (showMoveAllToTarget) {
        <vc-button
            aria-label="Move all to right"
            mode="icon-secondary"
            iconName="keyboard_double_arrow_right"
            [disabled]="moveAllToTargetButtonDisabled"
            (trigger)="onMoveAllToTarget()"></vc-button>
    }
    <vc-button
        aria-label="Move to left"
        mode="icon-secondary"
        iconName="chevron_left"
        [disabled]="moveToSourceButtonDisabled"
        (trigger)="onMoveToSource()"></vc-button>
    @if (showMoveAllToTarget) {
        <vc-button
            aria-label="Move all to left"
            mode="icon-secondary"
            iconName="keyboard_double_arrow_left"
            [disabled]="moveAllToSourceButtonDisabled"
            (trigger)="onMoveAllToSource()"></vc-button>
    }
</div>

<div class="vc-pick-list-target-panel">
    <div class="vc-pick-list-header">
        <span class="h4-heading">{{ targetLabel }}</span>
        @if (showTargetSearch) {
            <vc-input
                [placeholder]="targetSearchPlaceholder"
                [label]="targetSearchLabel"
                [showClear]="true"
                [prefixIcon]="'search'"
                [(value)]="targetSearch"></vc-input>
        }
    </div>
    <mat-selection-list
        cdkDropList
        class="vc-pick-list-selection-list vc-selection-list"
        [multiple]="multiselect"
        [tabIndex]="0"
        #doneList="cdkDropList"
        #targetList
        [disableRipple]="true"
        [cdkDropListData]="target"
        [cdkDropListConnectedTo]="[todoList]"
        [hideSingleSelectionIndicator]="true"
        [attr.aria-label]="targetAriaLabel"
        (selectionChange)="onTargetChange($event)"
        (cdkDropListDropped)="drop($event)">
        @for (item of target | search: targetSearchKey : targetSearch; track item; let i = $index) {
            <mat-list-option cdkDrag class="vc-pick-list-option" [value]="item">
                <ng-container
                    *ngTemplateOutlet="targetItemTemplate; context: { $implicit: item, index: i }"></ng-container>
            </mat-list-option>
        }
    </mat-selection-list>
</div>
